import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { motion } from "framer-motion";
import { Security, SupportAgent, Payment } from "@mui/icons-material";

// Trust and safety data (updated to avoid overlap)
const trustItems = [
  {
    title: "Verified Renters",
    description:
      "Every renter undergoes detailed screening to ensure safety and reliability.",
    icon: <Security sx={{ fontSize: 40, color: "secondary.main" }} />,
  },
  {
    title: "Help Desk",
    description:
      "Our team is available to assist you with any issues including listings, availability or reservations.",
    icon: <SupportAgent sx={{ fontSize: 40, color: "secondary.main" }} />,
  },
  {
    title: "Protected Transactions",
    description:
      "Secure, encrypted payments with dispute resolution for peace of mind.",
    icon: <Payment sx={{ fontSize: 40, color: "secondary.main" }} />,
  },
];

const TrustAndSafety = () => {
  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.5 },
    }),
    hover: { scale: 1.05, transition: { duration: 0.3 } },
  };

  // Animation for icon pulse
  const iconVariants = {
    pulse: {
      scale: [1, 1.1, 1],
      transition: { repeat: Infinity, duration: 2 },
    },
  };

  // Animation for background wave
  const waveVariants = {
    animate: {
      backgroundPosition: ["0% 0%", "100% 100%"],
      transition: { duration: 10, repeat: Infinity, repeatType: "reverse" },
    },
  };

  return (
    <Box
      className="trust-safety-section"
      sx={{ py: 8, position: "relative" }}
    >
      <motion.div
        className="trust-safety-background"
        variants={waveVariants}
        animate="animate"
      />
      <Typography variant="h2" color="text.primary" align="center" gutterBottom>
        Trust & Safety with AirKitchenz
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        align="center"
        sx={{ mb: 6, maxWidth: "600px", mx: "auto" }}
      >
        We prioritize your peace of mind with industry-leading safety and
        support.
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {trustItems.map((item, index) => (
          <Grid item xs={12} sm={4} key={item.title}>
            <motion.div
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              whileHover="hover"
              variants={cardVariants}
              className="trust-card"
            >
              <Box
                sx={{
                  textAlign: "center",
                  p: 3,
                  bgcolor: "#f9f9f9",
                  borderRadius: 2,
                }}
              >
                <motion.div variants={iconVariants} animate="pulse">
                  {item.icon}
                </motion.div>
                <Typography
                  variant="h6"
                  color="text.primary"
                  sx={{ mt: 2, mb: 1 }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  {item.description}
                </Typography>
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TrustAndSafety;
